export const EXCMDEVICESTATE_CREATE_RESET = 'EXCMDEVICESTATE_CREATE_RESET'
export const EXCMDEVICESTATE_CREATE_SET_CREATED = 'EXCMDEVICESTATE_CREATE_SET_CREATED'
export const EXCMDEVICESTATE_CREATE_SET_ERROR = 'EXCMDEVICESTATE_CREATE_SET_ERROR'
export const EXCMDEVICESTATE_CREATE_SET_VIOLATIONS = 'EXCMDEVICESTATE_CREATE_SET_VIOLATIONS'
export const EXCMDEVICESTATE_CREATE_TOGGLE_LOADING = 'EXCMDEVICESTATE_CREATE_TOGGLE_LOADING'
